import { graphql } from "react-relay";
import { SuggestionBodyAutopilot } from "./suggestion-body-autopilot";
import { SuggestionBodyConfigColors } from "./suggestion-body-config-colors";
import { SuggestionBodyConflictingMeeting } from "./suggestion-body-conflicting-meeting";
import { SuggestionBodyExpensiveMeeting } from "./suggestion-body-expensive-meeting";
import { SuggestionBodyExpensiveOrganizer } from "./suggestion-body-expensive-organizer";
import { SuggestionBodyLowFocusTime } from "./suggestion-body-low-focus-time";
import { SuggestionBodyOutOfOffice } from "./suggestion-body-out-of-office";
import { SuggestionBodyWeekInReview } from "./suggestion-body-week-in-review";
import { SuggestionBodyWeeklyAutopilotSummary } from "./suggestion-body-weekly-autopilot-summary";

export const suggestionBodyFragments = {
  org: graphql`
    fragment SuggestionBody_org on Org {
      ...SuggestionBodyAutopilot_org
      ...SuggestionBodyConfigColors_org
      ...SuggestionBodyConflictingMeeting_org
      ...SuggestionBodyExpensiveMeeting_org
      ...SuggestionBodyExpensiveOrganizer_org
      ...SuggestionBodyLowFocusTime_org
      ...SuggestionBodyOutOfOffice_org
      ...SuggestionBodyWeeklyAutopilotSummary_org
    }
  `,
  suggestionPayload: graphql`
    fragment SuggestionBody_suggestionPayload on SuggestionResultPayload {
      __typename
      ...SuggestionBodyAutopilot_suggestionPayload
      ...SuggestionBodyConflictingMeeting_suggestionPayload
      ...SuggestionBodyExpensiveMeeting_suggestionPayload
      ...SuggestionBodyExpensiveOrganizer_suggestionPayload
      ...SuggestionBodyLowFocusTime_suggestionPayload
      ...SuggestionBodyOutOfOffice_suggestionPayload
      ...SuggestionBodyWeekInReview_suggestionPayload
      ...SuggestionBodyWeeklyAutopilotSummary_suggestionPayload
      ... on SuggestionResultChromeExtensionTipPayload {
        tipType
      }
      ... on SuggestionResultMissingUserConfigurationPayload {
        configurationType
      }
    }
  `,
};
